export const ISOStringTranslator = (str?: string | null) =>
  str != "" && str != null
    ? Date.parse(str.substr(0,4) + "-" + str.substr(4,2) + "-" + str.substr(6,2) + "T" + str.substr(9,2) + ":" + str.substr(11,2) + ':00+09:00')
    : "";
